module.exports = __webpack_public_path__ + "img/multiplier_32.4f83d066.png";